import React, { Component } from "react";
import { Select } from "antd";

export class GroupsFilter extends Component {
  setQueryParam(param, value) {
    const query = new URLSearchParams(this.props.history.location.search);
    query.set(param, value);
    this.props.history.push({ search: query.toString() });
  }

  getGroupSelectFilterOptions(input, option) {
    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  onGroupChange = (value) => {
    if (value) {
      this.setQueryParam('groupId', value);
    } else {
      this.props.history.push({ search: value });
    }
  };

  render() {
    return (
      <Select allowClear className="church-members-table__group_filter" showSearch placeholder="Show all Groups"
              optionFilterProp="children"
              onChange={this.onGroupChange} filterOption={this.getGroupSelectFilterOptions}
              value={this.props.currentValue}>
        {
          this.props.data.church.groups.edges.map(edges => edges.node).map(group => {
            return (
              <Select.Option key={`church_group_id_${group.id}`} value={`${group.id}`}>
                {group.name}
              </Select.Option>
            );
          })
        }
      </Select>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/churchMembers/groupsFilter.js